import frUtils from '../util/frUtils';

( function ( _s ) {
	const modalId = 'team-card-modal';
	const _teamCardModal = _s( '#' + modalId );

	const loadMicroModalLibrary = ( libraryLoadedStatment, libArr, callback ) => {
		if ( libraryLoadedStatment ) {
			callback();
		} else {
			window.fetchInject( libArr ).then( () => {
				callback();
			} );
		}
	};

	if ( _teamCardModal.length ) {
		const targetElement = _teamCardModal.firstElement();

		const observerCallback = mutationsList => {
			for ( const mutation of mutationsList ) {
				if ( mutation.type === 'childList' ) {
					const _wysiwygContentInner = _teamCardModal.find( '.wysiwyg-content-inner' );

					if ( _wysiwygContentInner.length ) {
						_wysiwygContentInner.firstElement().scrollTop = 0;
					}
				}
			}
		};

		const observer = new MutationObserver( observerCallback );

		const config = {
			attributes: false,
			childList: true,
			subtree: true,
		};

		observer.observe( targetElement, config );
	}

	_s.fn.teamCardModal = function () {
		return this.el.forEach( el => {
			const _self = _s( el );
			const _cardsContainer = _self.find( '.cards-container' );
			let keyDownElement = false;

			const loadModalContent = _target => {
				const _card = _target.hasClass( 'card' ) ? _target : _target.closest( '.card' );

				const _cardGrid = _card.closest( '.cards-container' );
				var nodes = _cardGrid.length ? _cardGrid.find( '> .card' ).el : [];

				let colorClass = '';
				let cardIndex = [ ...nodes ].indexOf( _card.firstElement() ) + 1;

				const _modalContent = _card.find( '.card-modal-content' );

				if ( ( cardIndex - 2 ) % 4 === 0 ) {
					// Matches :nth-child(4n + 2)
					colorClass = 'green';
				} else if ( ( cardIndex - 3 ) % 4 === 0 ) {
					// Matches :nth-child(4n + 3)
					colorClass = 'red';
				} else if ( ( cardIndex - 4 ) % 4 === 0 ) {
					// Matches :nth-child(4n + 4)
					colorClass = 'blue';
				}

				_teamCardModal.find( '.modal__content' ).html( '' ).append( _modalContent.html() );

				_teamCardModal
					.removeClass( 'green' )
					.removeClass( 'red' )
					.removeClass( 'blue' )
					.addClass( colorClass );
			};

			const onShowModal = modal => {
				const memberName = _teamCardModal
					.find( '.modal-team-member-slug' )
					.attr( 'data-slug' );
				frUtils.init();
				frUtils.addHistoryUrlParam( 'member', memberName );
			};

			const onCloseModal = modal => {
				frUtils.init();
				frUtils.removeHistoryUrlParam( 'member' );
			};

			const showModal = () => {
				window.MicroModal.show( modalId, {
					onShow: onShowModal, // [1]
					onClose: onCloseModal, // [2]
					disableScroll: true,
				} );
			};

			const initCards = () => {
				const _cards = _self.find( '.cards-container > .card:not(.modal--initialized)' );

				_cards.on( 'click', e => {
					if ( e.target.tagName.toLowerCase() === 'a' ) e.preventDefault(); // Do nothing if phone or email addres links are clicked

					const _target = _s( e.target );

					loadModalContent( _target );

					showModal();
				} );

				_cards.on( 'keyup', e => {
					const _target = _s( e.target );

					/** Show modal only if the keyup event is preceded by a keydown event on the same element */
					if (
						window.isEventKeyEnter( e ) &&
						_target.hasClass( 'card' ) &&
						keyDownElement === _target.firstElement()
					) {
						loadModalContent( _target );

						showModal();
					}

					keyDownElement = false;
				} );

				_cards.addClass( 'modal--initialized' );
				_cards.addClass( 'is--initialized' );

				_cards.each( card => {
					const _card = _s( card );

					if ( ! _card.find( '.card-modal-content' ).length ) {
						_card.addClass( 'pe-none' );
					}
				} );
			};

			const loadMissingCardModalContent = member => {
				const _queryParameterMemberCard = _self.find(
					'.query-parameter-member[data-slug="' + member + '"]'
				);

				if ( _queryParameterMemberCard.length ) {
					const _modalContent = _queryParameterMemberCard.find( '.card-modal-content' );
					_teamCardModal
						.find( '.modal__content' )
						.html( '' )
						.append( _modalContent.html() );
					showModal();
				}
			};

			_cardsContainer.each( cardsContainer => {
				_s( cardsContainer ).on( 'fr:init-cards', () => {
					initCards();
				} );
			} );

			loadMicroModalLibrary(
				typeof window.MicroModal === 'object',
				[ 'https://unpkg.com/micromodal/dist/micromodal.min.js' ],
				() => {
					_s( window ).on( 'keydown', e => {
						keyDownElement = e.target;
					} );

					initCards();

					frUtils.init();
					if (
						frUtils.hasUrlParam( 'member' ) &&
						! _teamCardModal.hasClass( 'is-open' )
					) {
						const memberCard = _self.find(
							'.cards-container .card[data-slug="' +
								frUtils.getUrlParam( 'member' ) +
								'"]'
						);

						if ( memberCard.length ) {
							loadModalContent( memberCard );
							showModal();
						} else {
							loadMissingCardModalContent( frUtils.getUrlParam( 'member' ) );
						}
					}
				}
			);
		} );
	};

	_s( document ).ready( () => {
		_s( '.team-grid-module' ).teamCardModal();
	} );
} )( window._s );
